import CommentsHeader from './CommentsHeader'

export default CommentsHeader
// eslint-disable-next-line import/export
export * from './CommentsHeader'
